import React from 'react'
// import PropTypes from 'prop-types'
import { makeStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';
import styled from 'styled-components';

const useStyles = makeStyles((theme) => ({
  formControl: {
    // margin: theme.spacing(1),
    width: '100%',
    // marginBottom: '.5em'
  },
  textfield: {
    '& .MuiInputBase-root': {
      background: '#FFFFFF',
      border: '1px solid #CCCCCC',
      boxSizing: 'border-box',
      borderRadius: '12px',
      '&.Mui-focused': {
        background: '#FFFFFF',
        border: '1px solid #5E388A',
        '&:after': {
          display: 'none',
          borderBottom: 'none',
        },
      },
      '&:hover': {
        background: '#FFFFFF',
        '&:before': {
          borderBottom: 'none',
        },
      },
      '&:before': {
        borderBottom: 'none',
      },
      '& .MuiSelect-root': {
        fontFamily: 'Open Sans',
        fontStyle: 'normal',
        fontWeight: 'normal',
        fontSize: '15px',
        lineHeight: '20px',
        letterSpacing: '-0.005em',
        color: '#333333',
        // height: '2em'
      },
      '& input': {
        fontFamily: 'Open Sans',
        fontStyle: 'normal',
        fontWeight: 'normal',
        fontSize: '15px',
        lineHeight: '20px',
        letterSpacing: '-0.005em',
        color: '#333333',
      },
    },
    '& label': {
      fontSize: '14px',
      fontFamily: 'Open Sans',
      color: '#6A6A6A',
      '&.Mui-focused': {
        color: '#5E388A',
        fontWeight: 600
      },
      '&.MuiInputLabel-shrink': {
        color: '#5E388A'
      }
    },
    '& .MuiSvgIcon-root':{
      fill: '#5E388A'
    }
  }
}));
const ErrorText = styled.span`
  font-family: Open Sans;
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 16px;
  display: flex;
  align-items: center;
  color: #F15B5B;
  margin-left: .8em;
  margin-top: .1em;
`
const Container = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: .5em;
`
// const ModalSelect = ({ value, onChange, label, options }) => {
//   const classes = useStyles();
//   return (
//     <FormControl variant='filled' className={classes.formControl}>
//       <InputLabel className={classes.label} id="ModalSelect-labelID">{label}</InputLabel>
//       <Select
//         labelId="ModalSelect-labelID"
//         value={value}
//         onChange={onChange}
//         className={classes.select}
//         // input={<Input variant='filled' classes={inputClasses} />}
//         label={label}
//       >
//         <MenuItem value="">
//           <em>None</em>
//         </MenuItem>
//         {/* <MenuItem value={10}>Ten</MenuItem>
//         <MenuItem value={20}>Twenty</MenuItem>
//         <MenuItem value={30}>Thirty</MenuItem> */}
//         {options.map((o, i) => (
//           <MenuItem
//             key={`menuitem-${i}`}
//             value={o.value}>
//             {o.label}
//           </MenuItem>
//         ))}
//       </Select>
//     </FormControl>
//   )
// }
const ModalSelect = ({ name, value, onChange, label, options, disabled, error }) => {
  const classes = useStyles();
  return (
    <Container>
      <Autocomplete
        // onFocus={() => setFocused(true)}
        // onBlur={() => setFocused(false)}
        name={name}
        multiple={false}
        options={options}
        onChange={onChange}
        // disableCloseOnSelect
        disabled={disabled}
        autoComplete={true}
        getOptionLabel={(option) => option.label}
        value={value}
        className={classes.formControl}
        renderInput={(params) => (
          <TextField
            {...params}
            label={label}
            variant="filled"
            className={classes.textfield}
          />
        )}
      />
      {error && <ErrorText >{error}</ErrorText>}
    </Container>
  )
}

ModalSelect.defaultProps = {
  options: []
}

export default ModalSelect
